import React from 'react';
import { CTA_PREFIXES, useClickTracking } from '../../hooks/useClickTracking';

export interface TopBarProps {
  /** Heading text displayed in the top bar */
  text: string;
  /** Link text displayed beside the heading */
  linkText?: string;
  /** URL for the top bar link */
  linkUrl?: string;
  /** CTA tracking identifier for the link */
  ctaId?: string;
}

export const TopBar: React.FC<TopBarProps> = ({ text, linkText, linkUrl, ctaId }) => {
  const trackClick = useClickTracking(CTA_PREFIXES.footer, { ctaId, href: linkUrl, label: linkText });

  return (
    <div className="poly-page-footer__top-bar">
      <span>{text}</span>
      {linkText && linkUrl && (
        <a
          href={linkUrl}
          className="link-with-arrow"
          data-cta-id={ctaId || undefined}
          onClick={trackClick}
        >
          {linkText}
        </a>
      )}
    </div>
  );
};
